var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 81,
    viewBox: "0 0 75 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5562 19.7742C55.5562 30.145 47.1489 38.5522 36.7781 38.5522C26.4072 38.5522 18 30.145 18 19.7742C18 9.40333 26.4072 0.996094 36.7781 0.996094C47.1489 0.996094 55.5562 9.40333 55.5562 19.7742ZM63.7124 49.7158C70.6534 55.9096 74.5573 64.4644 74.7529 73.8727C71.1166 75.3505 56.0063 80.9961 37.376 80.9961C20.1473 80.9961 3.92113 75.3172 0 73.8425C0.203916 64.4459 4.10529 55.9031 11.0397 49.7158C17.9403 43.5597 27.2924 40.1695 37.376 40.1695C47.4597 40.1695 56.8117 43.5597 63.7124 49.7158Z",
    fill: "url(#paint0_linear_190_2054)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_190_2054",
    x1: 27.5,
    y1: 18.4961,
    x2: 56,
    y2: 68.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D0AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835083,
    stopColor: "#F19914"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.61fb7222145eb947a735463c03430d32.svg";
export { ForwardRef as ReactComponent };